import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { symbol as Symbol } from '@wix/santa-editor-symbols';

export default {
  ShapeIn: () => <Symbol name="motion-entrance-shape" />,
  FoldIn: () => <Symbol name="motion-entrance-fold" />,
  BlurIn: () => <Symbol name="motion-entrance-blur" />,
  FloatIn: () => <Symbol name="motion-entrance-float" />,
  BounceIn: () => <Symbol name="motion-entrance-bounce" />,
  TiltIn: () => <Symbol name="motion-entrance-tilt" />,
  ExpandIn: () => <Symbol name="motion-entrance-expand" />,
  GrowIn: () => <Symbol name="motion-entrance-grow" />,
  FadeIn: () => <Symbol name="motion-entrance-fade" />,
  SlideIn: () => <Symbol name="motion-entrance-slide" />,
  RevealIn: () => <Symbol name="motion-entrance-reveal" />,
  ArcIn: () => <Symbol name="motion-entrance-arc" />,
  GlideIn: () => <Symbol name="motion-entrance-glide" />,
  GlitchIn: () => <Symbol name="motion-entrance-glide" />,
  TurnIn: () => <Symbol name="motion-entrance-turn" />,
  SpinIn: () => <Symbol name="motion-entrance-spin" />,
  FlipIn: () => <Symbol name="motion-entrance-flip" />,
  WinkIn: () => <Symbol name="motion-entrance-wink" />,
  DropIn: () => <Symbol name="motion-entrance-drop" />,
  CircleIn: () => <Symbol name="motion-entrance-circle" />,
  CurveIn: () => <Symbol name="motion-entrance-curve" />,
  FlyIn: () => <Symbol name="motion-entrance-fly" />,
  PunchIn: () => <Symbol name="motion-entrance-punch" />,
};
